<template>
  <v-row>
    <v-col cols="12" style="position: relative;">
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="error"
          @click="cancel"
        >
          <v-icon small>mdi-close</v-icon>
        </v-btn>

        <div v-if="loading" class="text-center pa-6">
          <v-progress-circular
            :size="40"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>

        <v-card-text v-else>
          <v-form v-model="form.valid" ref="form" :disabled="form.disabled" lazy-validation>
            <v-text-field
              label="Title"
              v-model="form.data.title"
              :rules="form.rules.title"
              outlined
            />
            <v-textarea
              label="Description"
              v-model="form.data.description"
              outlined
            ></v-textarea>
            <v-text-field
              label="Video Url"
              v-model="form.data.url"
              :rules="form.rules.url"
              outlined
            />
            <v-checkbox
              v-model="form.data.is_active"
              label="Active"
            ></v-checkbox>

            <v-file-input
              small-chips
              label="Download file"
              ref="fileInput"
              :rules="form.rules.documents"
              :accept="acceptedDocumentTypesString"
              @change="downloadFiles"
            ></v-file-input>

            <template v-if="form.data.documents && form.data.documents.length > 0">
              <h4>Uploaded files</h4>
              <ul class="file-list">
                <li v-for="document in form.data.documents" :key="document.id">
                  <v-icon>{{ getIcon(document.format) }}</v-icon>
                  {{ document.name }}.{{ document.format }}
                  <v-btn icon @click="removeDocument(document.id)"><v-icon>mdi-close</v-icon></v-btn>
                </li>
              </ul>
            </template>

            <v-btn v-if="videoId" color="error" class="mr-4" v-text="'Delete'" @click="remove"></v-btn>
            <v-btn color="primary" class="mr-4" :disabled="!form.valid" v-text="'Save changes'" @click="save"></v-btn>
            <v-btn color="primary" outlined :disabled="!form.valid" v-text="'Cancel'" @click="cancel"></v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import {
  getVideoById,
  updateVideo,
  createVideo,
  deleteVideo,
  uploadVideoDocument,
  ROOT_FOLDER_ID,
 } from './api';

import { URL_PATTERN } from './../../../global/consts';

const ALLOWED_DOCUMENT_TYPE_ICONS = {
  // 'pdf': 'file-pdf-box',
  // 'xlsx': 'file-excel',
  // 'xls': 'file-excel',
  // 'docx': 'file-word',
  // 'pptx': 'file-powerpoint',
};

export default {
  name: 'JumpStartVideoEdit',
  data: () => ({
    loading: false,
    videoId: null,
    parentId: null,
    form: {
      disabled: false,
      valid: true,
      data: {
        title: '',
        description: '',
        documents: [],
        url: '',
        is_active: true,
      },
      rules: {
        title: [v => !!v || 'Title is required!'],
        description: [],
        documents: [v => !v || v.size < 10000000 || 'File should be less than 10 MB!'],
        url: [
          v => !!v || 'Video url is required!',
          v => URL_PATTERN.test(v) || 'Invalid url. URL must start with http or https'
        ],
      },
    },
    uploadedDocuments: [],
  }),
  computed: {
    acceptedDocumentTypesString() {
      return Object.keys(ALLOWED_DOCUMENT_TYPE_ICONS).map((f) => `.${f}`).join(',');
    },
    documents_ids() {
      return this.form.data.documents.map(({ id }) => id);
    }
  },
  mounted () {
    this.parentId = this.$route.query.parentId ?? ROOT_FOLDER_ID;
    this.videoId = this.$route.params.id
      ? parseInt(this.$route.params.id, 10)
      : null;

    if (this.videoId) {
      this.get();
    }
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.videoId) {
        this.update();
      } else {
        this.create();
      }
    },
    get() {
      this.loading = true;
      getVideoById(this.videoId)
        .then((video) => (this.form.data = { ...this.form.data, ...video}))
        .finally(() => (this.loading = false));
    },
    update() {
      this.loading = true;

      updateVideo(this.videoId, { ...this.form.data, documents_ids: this.documents_ids })
        .then(() => this.cancel())
        .finally(() => (this.loading = false));
    },
    create() {
      this.loading = true;

      createVideo({ ...this.form.data, documents_ids: this.documents_ids, content_folder_id: this.parentId })
        .then(() => this.cancel())
        .finally(() => (this.loading = false));
    },
    remove() {
      const text = {
        title: `Delete video`,
        text: `You are about to delete video «${this.form.data.title}». Are you sure to proceed?`,
      };

      this.$swal.fire(text.title, text.text)
        .then(({ isConfirmed }) => isConfirmed ? this.delete() : Promise.resolve());
    },
    downloadFiles(file) {
      if (!file) {
        return;
      }

      uploadVideoDocument(file)
        .then((response) => {
          if (response && response.data) {
            this.form.data.documents.push(response.data);
          }
        })
        .finally(() => this.$refs.fileInput.reset());
    },
    getIcon(format) {
      const icon = ALLOWED_DOCUMENT_TYPE_ICONS[format];
      return icon ? `mdi-${icon}` : `mdi-file-document`;
    },
    removeDocument(id) {
      this.form.data.documents = this.form.data.documents.filter((d) => d.id !== id);
    },
    delete() {
      this.loading = true;

      return deleteVideo(this.videoId).then(() => this.cancel());
    },
    cancel() {
      this.$router.push({
        name: 'system-admin-jump-start',
        query: { folderId: this.parentId },
      });
    },
  }
}
</script>

<style lang="scss" scoped>
  .file-list {
    padding: 10px 0;
    list-style: none;

    li {
      padding: 10px;
      
    }
  }
</style>